import {Component, Inject, OnChanges, OnInit, Optional} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry} from '@angular/material';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';

export interface FeedbackData {
    username: string;
    partner: string;
    account: string;
    feedback_type: any;
    feedback_message: string;
    csat_score: string;

}

@Component({
    selector: 'app-footer-old',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnChanges {
    termsAndconditions: any;
    privacyPolicy: any;
    FAQ: any;
    accept = false;
    userName: string;
    route: any;
    docData: any;
    feedbacktypes: FeedbackType[] = [
        {name: 'General Feedback', value: 'general'},
        {name: 'Feature Request', value: 'feature'},
        {name: 'Change Request', value: 'change'},
        {name: 'Service Issue', value: 'service'},
        {name: 'Technical Support', value: 'support'},
        {name: 'Partner Account Issue', value: 'account'},
        {name: 'Billing', value: 'billing'},
        {name: 'Bill/Invoice Request', value: 'invoice'},
        {name: 'Plans & Pricing', value: 'pricing'}
    ];
    feedbackSchema: any;
    stars = [
        {id: 1, icon: 'fa fa-star-o'},
        {id: 2, icon: 'fa fa-star-o'},
        {id: 3, icon: 'fa fa-star-o'},
        {id: 4, icon: 'fa fa-star-o'},
        {id: 5, icon: 'fa fa-star-o'}];
    stars1 = [
        {id: 1, icon: 'fa fa-star-o'},
        {id: 2, icon: 'fa fa-star-o'},
        {id: 3, icon: 'fa fa-star-o'},
        {id: 4, icon: 'fa fa-star-o'},
        {id: 5, icon: 'fa fa-star-o'}];
    socialIconData = [
        {
            name : 'linkedin',
            svg : './assets/linkedin.svg',
            link : 'https://www.linkedin.com/company/apiplatform-io'
        },
        {
            name : 'facebook',
            svg : './assets/facebook.svg',
            link : 'https://www.facebook.com/apiplatform.io'
        },
        {
            name : 'twitter',
            svg : './assets/twitter.svg',
            link : 'https://twitter.com/linxapiplatform'
        },
        {
            name : 'instagram',
            svg : './assets/instagram.svg',
            link : 'https://www.instagram.com/apiplatform.io/'
        },
        {
            name : 'youtube',
            svg : './assets/youtube.svg',
            link : 'https://www.youtube.com/channel/UCVgCJoYELVowFL-cS5WIHzQ'
        }
    ];
    constructor(private confPost: ConfService,
                public dialog: MatDialog,
                iconRegistry: MatIconRegistry, private Urlroute: ActivatedRoute,
                sanitizer: DomSanitizer,
                private router: Router,
                private location: Location,
                public appComponent: AppComponent,
                public platform: LeftpanelComponent) {
        this.router.events.subscribe(event => {
            this.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');
        });
        iconRegistry.addSvgIcon(
            'thumbs-up',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/examples/thumbup-icon.svg'));
        iconRegistry.addSvgIcon(
            'facebook-icon',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/facebook.svg'));
        iconRegistry.addSvgIcon(
            'facebook-box',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/facebook-box.svg'));
        iconRegistry.addSvgIcon(
            'linkedin-box',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/linkedin-box.svg'));
        iconRegistry.addSvgIcon(
            'twitter-box',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/twitter-box.svg'));
        iconRegistry.addSvgIcon(
            'feedback-icon',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/feedback-icon.svg'));
        iconRegistry.addSvgIcon(
            'youtube',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/youtube.svg'));
        iconRegistry.addSvgIcon(
            'instagram-box',
            sanitizer.bypassSecurityTrustResourceUrl('./assets/instagram.svg'));
    }
    ngOnChanges() {
    }

    ngOnInit() {
        this.confPost.getTermsAndConditions().subscribe(data => {
            this.termsAndconditions = data;
        });
        this.confPost.getFAQ().subscribe(data => {
            this.FAQ = data;
        });
        this.confPost.getPrivacyPolicy().subscribe(data => {
            this.privacyPolicy = data;
        });
        this.feedbackSchema = {
            username: '',
            partner: '',
            account: '',
            feedback_type: this.feedbacktypes,
            feedback_message: '',
            csat_score: ''
        };
    }
    openDialog() {

        const dialogRef = this.dialog.open(LegalComponent, {
            data: this.termsAndconditions
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
        });
    }
    openFAQDialog() {
        const dialogRef = this.dialog.open(FaqComponent, {
            data: this.FAQ
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
        });
    }
    setRating(val) {
        let temp = val + 1;
        for (let i = 0; i <= val; i++) {
            this.stars1[i]['icon'] = 'fa fa-star';
        }
        for (let i = val + 1; i < 5; i++) {
            this.stars1[i]['icon'] = 'fa fa-star-o';
        }
        const dialogRef = this.dialog.open(DialogComponent, {
            data: {
                type: 'feedback',
                message: 'Are you sure you want to rate this page with a ',
                number: val + 1,
                stars: this.stars1
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'no') {
                let temp = val + 1;
                for (let i = 0; i <= val; i++) {
                    this.stars[i]['icon'] = 'fa fa-star';
                }
                for (let i = val + 1; i < 5; i++) {
                    this.stars[i]['icon'] = 'fa fa-star-o';
                }
                this.route = this.location.path();
                const timestamp = new Date();
                let payload = {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    component: this.route,
                    rating: temp,
                    timestamp: timestamp.getTime()
                };
                this.confPost.postFeedback(payload, 'v1', 'ratings').subscribe(data => {
                });
            }
        });
    }
    openPrivacyPolicyDialog() {

        const dialogRef = this.dialog.open(LegalComponent, {
            data: this.privacyPolicy
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
        });
    }

    guideMe(): void {
        if (this.location.path() !== '') {
            this.route = this.location.path();
            if (this.route === '/console') {
                this.platform.guidedTourService.startTour({
                    tourId: 'console-tour',
                    useOrb: false,
                    steps: this.platform.getConsoleTourSteps()
                });
            } else if (this.route === '/dataaccessapi') {
                this.platform.guidedTourService.startTour({
                    tourId: 'data-access-service-creator',
                    useOrb: false,
                    steps: this.platform.getDaasTourSteps()
                });
            } else if (this.route === '/businesslogic' || this.route.includes('/businesslogic/edit?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'business-logic-creator',
                    useOrb: false,
                    steps: this.platform.getBusinessLogicTourSteps()
                });
            } else if (this.route === '/querybuilder' || this.route.includes('/querybuilder?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'query-builder-creator',
                    useOrb: false,
                    steps: this.platform.getQueryBuilderTourSteps()
                });
            } else if (this.route === '/plsql' || this.route.includes('/plsql?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'plsql-creator',
                    useOrb: false,
                    steps: this.platform.getPlSqlTourSteps()
                });
            } else if (this.route === '/dataaccessapi-advanced') {
                this.platform.guidedTourService.startTour({
                    tourId: 'data-access-api-advanced-creator',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/apitoapi') {
                this.platform.guidedTourService.startTour({
                    tourId: 'open-api-to-api-creator',
                    useOrb: false,
                    steps: this.platform.getApiToApiSteps()
                });
            } else if (this.route === '/jsontoapi') {
                this.platform.guidedTourService.startTour({
                    tourId: 'json-schema-api-creator',
                    useOrb: false,
                    steps: this.platform.getJsonSchemaTourSteps()
                });
            } else if (this.route === '/openapitoapi') {
                this.platform.guidedTourService.startTour({
                    tourId: 'open-api-to-api-creator',
                    useOrb: false,
                    steps: this.platform.getYamlTourSteps()
                });
            } else if (this.route === '/coboltoapi') {
                this.platform.guidedTourService.startTour({
                    tourId: 'cobol-to-api-creator',
                    useOrb: false,
                    steps: this.platform.getCobolTourSteps()
                });
            } else if (this.route === '/testsuite') {
                this.platform.guidedTourService.startTour({
                    tourId: 'test-suite-api-creator',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/devex' || this.route.includes('/devex?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'devex-tester',
                    useOrb: false,
                    steps: this.platform.getDevexPageTourSteps()
                });
            } else if (this.route === '/api-register') {
                this.platform.guidedTourService.startTour({
                    tourId: 'api-register',
                    useOrb: false,
                    steps: this.platform.getApiRegisterSteps()
                });
            } else if (this.route === '/filestorage') {
                this.platform.guidedTourService.startTour({
                    tourId: 'file-storage',
                    useOrb: false,
                    steps: this.platform.getFileManagerTourSteps()
                });
            } else if (this.route === '/provider-category') {
                this.platform.guidedTourService.startTour({
                    tourId: 'provider-category',
                    useOrb: false,
                    steps: this.platform.getServiceProviderCategoriesTourSteps()
                });
            } else if (this.route === '/providers') {
                this.platform.guidedTourService.startTour({
                    tourId: 'service-providers',
                    useOrb: false,
                    steps: this.platform.getServiceProvidersTourSteps()
                });
            } else if (this.route === '/controlplane') {
                this.platform.guidedTourService.startTour({
                    tourId: 'control-plane',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/datacatalog') {
                this.platform.guidedTourService.startTour({
                    tourId: 'datacatalog',
                    useOrb: false,
                    steps: this.platform.getDataCatalogTourSteps()
                });
            } else if (this.route === '/email-templates') {
                this.platform.guidedTourService.startTour({
                    tourId: 'email-templates',
                    useOrb: false,
                    steps: this.platform.getEmailTemplatesTourSteps()
                });
            } else if (this.route === '/emailtemplatebuilder' || this.route.includes('/emailtemplatebuilder?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'email-template-builder',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/executeemailtemplate' || this.route.includes('/executeemailtemplate?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'execute-email-template',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/workflow' || this.route.includes('/workflow?')){
                this.platform.guidedTourService.startTour({
                    tourId: 'workflow-builder',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/databases' || this.route.includes('/databases?')){
                this.platform.guidedTourService.startTour({
                    tourId: 'databases',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/unified-query-builder' || this.route.includes('/unified-query-builder?')){
                this.platform.guidedTourService.startTour({
                    tourId: 'unified-query-builder',
                    useOrb: false,
                    steps: this.platform.getGuideTourSteps()
                });
            } else if (this.route === '/postman-collections' || this.route.includes('/postman-collections?')){
                this.platform.guidedTourService.startTour({
                    tourId: 'postman-collections',
                    useOrb: false,
                    steps: this.platform.getPostmanCollectionTourSteps()
                });
            } else if (this.route === '/application' || this.route.includes('/application?')){
                this.platform.guidedTourService.startTour({
                    tourId: 'application',
                    useOrb: false,
                    steps: this.platform.getOpenAPITourSteps()
                });
            } else if (this.route === '/test-results' || this.route.includes('/test-results?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'test-results',
                    useOrb: false,
                    steps: this.platform.getTestResultsTourSteps()
                });
            } else if (this.route === '/apiql' || this.route.includes('/apiql?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'apiql',
                    useOrb: false,
                    steps: this.platform.getAPIQLTourSteps()
                });
            } else if (this.route === '/dataql' || this.route.includes('/dataql?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'dataql',
                    useOrb: false,
                    steps: this.platform.getDATAQLTourSteps()
                });
            } else if (this.route === '/collection' || this.route.includes('/collection?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'collection',
                    useOrb: false,
                    steps: this.platform.getAPICollectionsTourSteps()
                });
            } else if (this.route === '/scheduler' || this.route.includes('/scheduler?')) {
                this.platform.guidedTourService.startTour({
                    tourId: 'scheduler',
                    useOrb: false,
                    steps: this.platform.getSchedulerTourSteps()
                });
            } else {
                this.platform.guidedTourService.startTour({
                    tourId: 'default-tour',
                    useOrb: false,
                    steps: [
                        {
                            title: 'Dear ' + localStorage.getItem('signInEmail'),
                            content: this.platform.getProperty('GT_DEFAULT_TOUR_CONTENT'),
                        }
                    ]
                });
                // this.platform.openSnackBar('Sorry, Guided Tour is not available for this page as of now. Please be patience while we are adding the tour to guide you!' , 'Error', {
                //     duration: 7000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        }
    }

    openFeedbackDialog(): void {
        const dialogRef = this.dialog.open(FeedbackComponent, {
            disableClose: true,
            width: '550px',
            data: this.feedbackSchema
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    navigateToLinkedIn() {
        this.router.navigate(['https://www.linkedin.com/company/apiplatform-io/about/?viewAsMember=true']);
    }
    navigateToTwitter() {
        this.router.navigate(['https://twitter.com/Apiplatformio']);
    }
}
import {FormControl, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material';
import {Location} from '@angular/common';
import {DialogData} from '../partner-onboard/partner-onboard.component';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {GuidedTourService} from 'ngx-guided-tour';
import {AppComponent} from '../app.component';
import {CrudapiAdvancedComponent} from '../crudapi-advanced/crudapi-advanced.component';
import { withLatestFrom } from 'rxjs-compat/operator/withLatestFrom';
export interface FeedbackType {
    name: string;
    value: string;
}
@Component({
    selector: 'feedback-dialog',
    templateUrl: 'feedback.component.html',
    styleUrls: ['feedback.component.css'],
})
export class FeedbackComponent {

    constructor(
        private confPost: ConfService,
        public platform: LeftpanelComponent, public dialogRef: MatDialogRef<FeedbackComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FeedbackData,
        private location: Location) {
    }
    feedbackSchema = {
        username: '',
        partner: '',
        account: '',
        feedback_type: '',
        feedback_message: '',
        csat_score: ''
    };
    route: any;
    selectedOption: string;
    feedbackOptions: string[] = ['Good', 'Neutral', 'Bad'];
    selectFeedbackTypeControl = new FormControl('', Validators.required);
    feedbacktypes: FeedbackType[] = [
        {name: 'General Feedback', value: 'general'},
        {name: 'Feature Request', value: 'feature'},
        {name: 'Change Request', value: 'change'},
        {name: 'Service Issue', value: 'service'},
        {name: 'Technical Support', value: 'support'},
        {name: 'Partner Account Issue', value: 'account'},
        {name: 'Billing', value: 'billing'},
        {name: 'Bill/Invoice Request', value: 'invoice'},
        {name: 'Plans & Pricing', value: 'pricing'}
    ];
    onNoClick(): void {
        this.dialogRef.close();
    }
    sendFeedback(result) {
        this.feedbackSchema.partner = localStorage.getItem('partner');
        this.feedbackSchema.account = localStorage.getItem('account');
        this.feedbackSchema.username = 'experience@apiplatform.io';
        this.route = this.location.path();
        let payload = {
            partner: this.feedbackSchema.partner,
            service: this.route,
            feedback: this.feedbackSchema.feedback_message,
            label: this.feedbackSchema.feedback_type,
            tag: this.feedbackSchema.csat_score
        };
        this.confPost.sendFeedback(this.feedbackSchema).subscribe(data => {
            this.confPost.postFeedback(payload, 'v1', 'user-feedback').subscribe(data1 => {
                this.platform.openSnackBar('Feedback has been sent successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.platform.openSnackBar('Error while sending feedback' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }, error => {
            this.platform.openSnackBar(error.error.message, 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }
}

@Component({
    selector: 'dialog-content-example-dialog',
    templateUrl: 'legal.component.html',
    styleUrls: ['legal.component.css']
})
export class LegalComponent {
    constructor(
        public dialogRef: MatDialogRef<LegalComponent>,
        public platform: LeftpanelComponent,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }
}

@Component({
    selector: 'dialog-content-example-dialog',
    templateUrl: 'faq.component.html',
    styleUrls: ['faq.component.css']
})
export class FaqComponent {
    constructor(
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<LegalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }
}
